import React, { useEffect } from "react";
import { useFormik } from "formik";
import { Box, Flex, Icon } from "@chakra-ui/react";
import { useReportability } from "../../../hooks/Reportability";
import { GetStatus, ZonesTwoList, ProgramsList, Months } from "../../../Utils";

import { Button, InputComtrol, Select, Select2 } from "../../UI";
import { SearchIcon } from "../../Icons";

const Filters = ({ setFilters, isLoadingData }) => {
  const {
    data: arrayYears,
    isLoading,
    isFetching,
  } = useReportability("YEARS-PROGRAMS", []);

  const initialValues = {
    state: GetStatus?.list?.filter((item) => item.key !== "").at(0).key || "",
    year: new Date().getFullYear(),
    month: "Todos",
    zone: ["TODOS", ...ZonesTwoList.getRegions()].at(0),
    type: [{ key: "TODOS", name: "TODOS" }, ...ProgramsList].at(0).key,
  };

  const formik = useFormik({
    initialValues,
    validateOnMount: false,
    validateOnChange: false,
    onSubmit: (values) => {
      setFilters(values);
    },
  });

  const handleChangeSelect = (value, type) => {
    if (type === "ZONE") {
      formik.setValues({
        ...formik.values,
        zone: value,
      });
    }
    if (type === "YEAR") {
      formik.setValues({
        ...formik.values,
        year: value,
      });
    }
    if (type === "STATE") {
      formik.setValues({
        ...formik.values,
        state: value,
      });
    }
    if (type === "TYPE") {
      formik.setValues({
        ...formik.values,
        type: value,
      });
    }
    if (type === "MONTH") {
      formik.setValues({
        ...formik.values,
        month: value === "Todos" ? null : Months.getNumberMonth(value),
      });
    }
  };

  useEffect(() => {
    if (arrayYears?.length > 0) {
      formik.setValues({
        ...formik.values,
        year: Math?.max(...arrayYears) || new Date().getFullYear(),
      });
    }
  }, [arrayYears]);

  return (
    <>
      {!isLoading && !isFetching && (
        <Flex
          direction={{
            lg: "row",
            md: "column",
            sm: "column",
          }}
          justify={"center"}
          align={{
            lg: "center",
            md: "flex-end",
            sm: "flex-end",
          }}
          gap={2}
        >
          <InputComtrol id={"type"} label={"Beneficio"} isRequired={false}>
            <Select2
              list={[{ key: "TODOS", name: "TODOS" }, ...ProgramsList]}
              value={formik.values.type}
              bg={"white"}
              onChange={(value) => handleChangeSelect(value, "TYPE")}
            />
          </InputComtrol>
          <InputComtrol id={"state"} label={"Resolución"} isRequired={false}>
            <Select2
              list={GetStatus?.list?.filter((item) => item.key !== "")}
              value={formik.values.state}
              bg={"white"}
              onChange={(value) => handleChangeSelect(value, "STATE")}
            />
          </InputComtrol>
          <InputComtrol id={"zone"} label={"Zona"} isRequired={false}>
            <Select
              list={["TODOS", ...ZonesTwoList.getRegions()]}
              value={formik.values.zone}
              bg={"white"}
              onChange={(value) => handleChangeSelect(value, "ZONE")}
            />
          </InputComtrol>
          <InputComtrol id={"year"} label={"Año"} isRequired={false}>
            <Select
              list={arrayYears}
              value={formik.values.year}
              bg={"white"}
              onChange={(value) => handleChangeSelect(value, "YEAR")}
            />
          </InputComtrol>
          <InputComtrol id={"month"} label={"Mes"} isRequired={false}>
            <Select
              list={["Todos", ...Months.getArrayNamesMonths()]}
              value={formik.values.month}
              bg={"white"}
              onChange={(value) => handleChangeSelect(value, "MONTH")}
            />
          </InputComtrol>
          <Box>
            <Button
              text={"Buscar"}
              rightIcon={<Icon as={SearchIcon} color={"white"} />}
              disabled={isLoading || isFetching || arrayYears?.length === 0}
              isLoading={isLoadingData}
              onClick={formik.handleSubmit}
            />
          </Box>
        </Flex>
      )}
    </>
  );
};

export default Filters;
